import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { shopApi } from "../context/ShopAuthContext";

export const AccountAccessPanel = () => {
  const [access, setAccess] = useState(null);
  const [agent, setAgent] = useState(null);
  useEffect(() => {
    shopApi.get("/customer-access/status").then(r => setAccess(r.data)).catch(() => setAccess({status:"unavailable"}));
    shopApi.get("/agent-access/me").then(r => setAgent(r.data)).catch(() => {});
  }, []);
  const statuses = { verification_required: "E-mailverificatie vereist", review_required: "Klantkoppeling in medewerkerscontrole", onboarding_required: "Klantprofiel nog niet afgerond", unavailable: "Klanttoegang tijdelijk niet beschikbaar", linked: "Klantaccount gekoppeld" };
  return <section className="mb-6 border-b border-gray-200 pb-6 space-y-3" data-testid="customer-access-panel">
    <p className="text-sm font-medium" data-testid="customer-access-status">{access ? statuses[access.status] : "Klanttoegang laden…"}</p>
    {access?.customer_number && <p className="text-sm" data-testid="customer-access-number">Klantnummer: {access.customer_number}</p>}
    {access?.status === "onboarding_required" && <Link to="/account/onboarding" className="text-sm underline text-blue-700" data-testid="customer-complete-onboarding">Profiel afronden</Link>}
    {agent && <Link to="/agent" className="inline-block text-sm font-semibold underline text-blue-700" data-testid="customer-agent-portal">Agentomgeving — {agent.name}</Link>}
  </section>;
};